<template>
  <div>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" style="margin-bottom:80px;margin-top:0px">
      <el-card>
        <div slot="header">基本信息</div>
        <div class="flex flex-align-center flex-justify-between flex-wrap" style="gap:20px 0;width:80%">
          <el-form-item label="分销商：" class="width45">
            <el-select v-model="form.EmployeeId" style="width:100%" filterable :disabled="userInfo.IsDistribution">
              <el-option v-for="(v,i) in distributorList" :key="i" :value="v.Id" :label="v.EmployeeName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外部单号：" class="width45" prop="OutOrderNo">
            <el-input v-model="form.OutOrderNo" placeholder="外部系统订单编号" maxlength="50"></el-input>
          </el-form-item>
        </div>
      </el-card>
      <el-card class="margin-top-10">
        <div slot="header">商品信息</div>
        <div>
          <el-button type="text" @click="toChoose">选择商品</el-button>
          <el-table :data="form.tablelist" style="width:70%">
            <el-table-column prop="" label="商品" min-width="150">
              <template slot-scope="scope">
                <div class="flex flex-align-center gap-10">
                  <img :src="scope.row.ImgUrlComplete" style="width:60px;height:60px;flex-shrink:0" alt="">
                  <div class="ellipsis">
                    {{scope.row.Name}}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="规格">
              <template slot-scope="scope">
                <div class="ellipsis-two">
                  {{scope.row.SpecValue||'默认规格'}}
                  <span v-if="scope.row.SpecValue2">;{{scope.row.SpecValue2}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="规格条形码">
              <template slot-scope="scope">
                <div class="ellipsis">
                  {{scope.row.Barcode||'--'}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="单价(元)">
              <template slot-scope="scope">
                <div>
                  {{scope.row.SpeciaPriceId||scope.row.DistributePriceId?scope.row.SinglePrice:'--'}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="企店价格(元)" v-if="!userInfo.IsDistribution">
              <template slot-scope="scope">
                <div>
                  {{scope.row.DistributePriceId?scope.row.QiDianDistributePrice:'--'}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="报单数量(个)">
              <template slot-scope="scope">
                <el-form-item label-width="0" :prop="'tablelist.'+scope.$index+'.ProductCount'" :rules="rules.ProductCount" style="margin-top:20px">
                  <el-input v-model="scope.row.ProductCount" style="width:120px" 
                    onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                    onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  @blur="assign(scope.row)"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" style="color:#f56c6c" @click="del(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination v-if="Total" style="margin-top:10px" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 20, 30, 40]"
            :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="Total">
          </el-pagination>
        </div>
      </el-card>
      <el-card class="margin-top-10">
        <div slot="header">收货信息</div>
        <el-form-item label="收货人" class="width45" prop="ReceiveName">
          <el-input v-model="form.ReceiveName" placeholder="收货人姓名" style="width:430px" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item label="手机号" class="width45" prop="ReceivePhone">
          <el-input v-model="form.ReceivePhone" placeholder="收货人手机号" style="width:430px" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="省市区" class="width45" prop="address">
          <el-cascader v-model="form.address" :options="dataList" :props="{value:'name',label:'name',children:'child'}" style="width:430px"
            @change="chooseAddress"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" class="width45" prop="ReceiveAddress">
          <el-input v-model="form.ReceiveAddress" type="textarea" :rows="6" placeholder="详细地址" style="width:430px" maxlength="100"></el-input>
        </el-form-item>
      </el-card>
      <el-card class="margin-top-10">
        <div slot="header">其他信息</div>
        <el-form-item label="买家留言" class="width45">
          <el-input v-model="form.CustomerRemark" placeholder="买家留言内容" style="width:430px" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="卖家备注" class="width45">
          <el-input v-model="form.SystemRemark" placeholder="分销商备注内容" style="width:430px" maxlength="100"></el-input>
        </el-form-item>
      </el-card>
    </el-form>
    <div class="bottom-button">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="checkForm">提交订单</el-button>
    </div>

    <shoplist :show="chooseShow" @close="chooseShow=false" @confirm="getShop" :data="form.ProductInfoList" :Id="form.EmployeeId"></shoplist>
  </div>
</template>

<script>
import shoplist from "../components/shopList"
import {
  cittaDistributiondistributorList,
  cittaDistributionOrdersubmit,
} from "@/api/sv3.0.0"
import {
  employeeloginEmployeeInfo
} from "@/api/login"
import axios from 'axios'
export default {
  components:{
    shoplist
  },
  data () {
    return {
      form:{
        EmployeeId:null,
        OutOrderNo:'',
        ProductInfoList:[],
        ReceiveName:'',
        ReceiveAddress:'',
        address:[],
        ReceivePhone:'',
        CustomerRemark:'',
        SystemRemark:'',
        ReceiveProvince:'',
        ReceiveCity:'',
        ReceiveArea:'',
        tablelist:[]
      },
      rules:{
        OutOrderNo:[
          { required: true, message: '请输入外部系统订单编号', trigger: 'blur' }
        ],
        ProductCount:[{
          validator: (rule, value, callback)=>{
            if(value<1||value>99999){
              callback(new Error('请输入正确的数量'))
            }
            callback()
          }, trigger: 'blur'
        }],
        ReceiveName:[
          { required: true, message: '请输入收货人姓名', trigger: 'blur' }
        ],
        ReceivePhone:[
          { required: true, message: '请输入收货人手机号', trigger: 'blur' }
        ],
        address:[
          { required: true, message: '请完善收货地址', trigger: 'blur' ,type:'array'}
        ],
        ReceiveAddress:[
          { required: true, message: '请完善收货地址', trigger: 'blur' }
        ],
      },
      Total:0,
      currentPage:1,
      pageSize:5,
      options:[],
      chooseShow:false,
      distributorList:[],
      dataList:[],
      userInfo:{}
    }
  },
  mounted () {
    this.getdistributorList()
    this.getUserInfo()
    this.getDataList()
  },
  methods: {
    toChoose(){
      // if(!this.form.EmployeeId){
      //   this.$message.error('请选择分销商')
      //   return 
      // }
      this.chooseShow = true
    },
    async getUserInfo(){
      try{
        let res = await employeeloginEmployeeInfo({})
        if(res.IsSuccess){
          this.userInfo = res.Result
          if(this.userInfo.IsDistribution){
            this.form.EmployeeId = this.userInfo.EmployeeId
          }
          // console.log(this.form.EmployeeId)
        }
      }finally{
        //
      }
    },
    //获取地址数据
    getDataList() {
      var that = this
      axios.get('https://cdn.dkycn.cn/JSON/gdDistrict-v2.json?v='+new Date().getTime(), {})
        .then(function(response) {
          that.dataList = response.data
        })
        .catch(function(error) {})
    },
    async getdistributorList(){
      try{
        let res = await cittaDistributiondistributorList({
          EmployeeState:1,
          Skip:0,
          Take:99999
        })
        if(res.IsSuccess){
          this.distributorList = res.Result.Results
        }
      }finally{
        //
      }
    },
    chooseAddress(e){
      [this.form.ReceiveProvince='',this.form.ReceiveCity='',this.form.ReceiveArea=''] = e
    },
    assign(row){
      this.form.ProductInfoList = this.form.ProductInfoList.map(v=>{
        if(v.ProductId==row.ProductId){
          v.ProductCount = row.ProductCount
        }
        return v
      })
    },
    del(row){
      this.form.ProductInfoList = this.form.ProductInfoList.filter(v=>{
        return v.ProductId!=row.ProductId
      })
      this.gettablelist()
    },
    getShop(e){
      let old = JSON.parse(JSON.stringify(this.form.ProductInfoList))
      this.form.ProductInfoList = JSON.parse(JSON.stringify(e.map(v=>{
        v.ProductCount = 1
        let item = old.find(x=>x.ProductId==v.ProductId)
        if(item){
          v.ProductCount = item.ProductCount
        }
        return v
      })))
      this.gettablelist()
      this.chooseShow = false
    },
    checkForm(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(!this.form.ProductInfoList.length){
            this.$message.error('请添加订单商品')
            return 
          }
          this.submit()
        } else {
          return false;
        }
      });
    },
    async submit(){
      try{
        this.pageloading = true
        let res = await cittaDistributionOrdersubmit({
          ...this.form,
          ProductInfoList:this.form.ProductInfoList.map(v=>{
            return {
              ProductId:v.ProductId,
              ProductSpecId:v.ProductSpecId,
              ProductCount:v.ProductCount
            }
          })
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.$router.push({
            path:'/XITAIDistribution/XITAIDistributorOrder'
          })
        }
      }finally{
        this.pageloading = false
      }
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pageSize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    gettablelist(){
      this.Total = this.form.ProductInfoList.length
      this.form.tablelist = this.form.ProductInfoList.filter((v,i)=>{
        return i>=(this.currentPage-1)*this.pageSize&&i<this.currentPage*this.pageSize
      })
      if(!this.form.tablelist.length&&this.currentPage>1){
        this.gettablelist()
        return 
      }
    },
  }
}
</script>

<style lang='less' scoped>
.width45{
  width:47%
}
.bottom-button{
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 5%;
  background: white;
}
</style>